import { reduce } from 'lodash';
import { WINDOW_SIZE } from './constants';

/**
 * Exposes an api for managing a single window instance visible to the user.
 *
 * The window has a predetermined size and will be opened in a new tab in
 * case the viewport does not enable it to open on the same tab.
 */
class SocialAuthenticationWindow {
    private windowRef: Window | null;

    constructor() {
        this.windowRef = null;
    }

    open(url: string, name: string) {
        this.windowRef = window.open(url, name, this.features);

        this.windowRef?.focus();

        return this.windowRef;
    }

    close() {
        if (!this.windowRef) {
            return;
        }

        this.windowRef.close();

        this.windowRef = null;
    }

    get current() {
        return this.windowRef;
    }

    get features() {
        const properties = {
            height: WINDOW_SIZE.HEIGHT,
            width: WINDOW_SIZE.WIDTH,
            top: window.screen.height / 2 - WINDOW_SIZE.HEIGHT / 2,
            left: window.screen.width / 2 - WINDOW_SIZE.WIDTH / 2,
        };

        const features = reduce(
            properties,
            (accumulatedFeatures: string[], value, key) => {
                accumulatedFeatures.push(`${key}=${value}`);
                return accumulatedFeatures;
            },
            []
        );

        return features.join(',');
    }
}

export default new SocialAuthenticationWindow();
